import { useMediaQuery } from "@mantine/hooks";

/**
 * Ekran genişliği 48em (768px) veya altında ise true döner.
 * SSR-safe: sunucuda false döner.
 */
export const useIsMobile = (): boolean =>
  useMediaQuery("(max-width: 48em)") ?? false;
